import React from 'react'
import {
    Window, TabBar, Form, Input,
    Checkbox, PhoneHint, PasswordHint,
    Parallax, License, Providers, ProviderItem,
    LinkButton
} from 'common/components'
import {Http, Credential, BASE_URL} from 'common'
import {AuthOptions} from '../../utils'
import {Link} from 'react-router-dom'
import {Row, Col, Tooltip, Popover} from 'antd'


export default class SignIn extends React.Component {
    state = {
        loginType: 'email',
        disabled: false
    }

    handleSubmit = async (data) => {
        await this.setState({
            loginType: `${Credential.typeOf(data.login)}`,
            disabled: true
        })

        document.getElementById('loginForm').submit()
    }

    linkToForgetPassword = () => (
        <Link to="/passwordrecovery" className="auth__form-label-right">
            Забули пароль?
        </Link>
    )

    renderProviders = (options) => (
        <div>
            <Row>
                {options.providers().map((item, index) => (
                    <Col key={index} span={8}>
                        <ProviderItem key={item.id} content={item} />
                    </Col>
                ))}
            </Row>
        </div>
    )

    render() {
        const {params} = this.props
        const {loginType, disabled} = this.state
        const options = new AuthOptions(params)

        const inputs = options.inputs()
        const hasPhone = inputs.includes('phone')
        const onlyProviders = inputs.length === 0

        if (onlyProviders) {
            return this.renderProviders(options)
        }

        return (
            <div>
                <Form
                    label='Увійти в Київ ID'
                    action={`${BASE_URL}/login/${loginType}`}
                    method='post'
                    id='loginForm'
                    onSubmit={this.handleSubmit}
                    disabled={disabled}
                    csrf
                >
                    <Input
                        type='credential'
                        title={options.title()}
                        name='login'
                        hint={() => hasPhone ? <PhoneHint /> : <span></span>}
                        tabIndex='1'
                        autoFocus
                    />

                    <Input
                        type='password'
                        title='Пароль'
                        name='password'
                        hint={this.linkToForgetPassword}
                        tabIndex="2"
                    />
                </Form>

                <Providers
                    title='Або скористайтесь'
                    config={options.providers()}
                    disable={false}
                />
            </div>
        )
    }
}
